import React, { Component, useState, useEffect, useContext } from 'react'

import classNames from 'classnames'

import { connect } from 'react-redux'
import { withRouter, Link } from 'react-router-dom'

import { getBusinessInfo, getUser, getCompanies, setActiveCompany, login, logout } from '../../store/alpha'

import ResizeDetector, { withResizeDetector } from 'react-resize-detector'

import SearchBar from './SearchBar'
import SearchBarView from '../../app/client/views/SearchBarView'

import { withStyles } from '@material-ui/core/styles'
import useMediaQuery from '@material-ui/core/useMediaQuery'

import Paper from '@material-ui/core/Paper'
import Button from '@material-ui/core/Button'
import Typography from '@material-ui/core/Typography'
import AccountCircleIcon from '@material-ui/icons/AccountCircle'
import FiberManualRecordIcon from '@material-ui/icons/FiberManualRecord'
import Box from '@material-ui/core/Box'
import Badge from '@material-ui/core/Badge'
import Menu from '@material-ui/core/Menu'
import MenuItem from '@material-ui/core/MenuItem'
import Popover from '@material-ui/core/Popover'
import ListItemIcon from '@material-ui/core/ListItemIcon'
import ListItemText from '@material-ui/core/ListItemText'
import Divider from '@material-ui/core/Divider'
import BusinessIcon from '@material-ui/icons/Business'
import UserIcon from '@material-ui/icons/AccountCircle'

import CheckedIcon from '@material-ui/icons/Check'
import UncheckedIcon from '@material-ui/icons/Done'

const styles = theme => ({
  root: {
    backgroundColor: '#ffffff',
    width: '100%',
    height: 52,
    borderBottom: 'solid 1px #dddddd',
    display: 'flex',
    justifyItems: 'center',
    alignItems: 'center',
    paddingLeft: theme.spacing(1),
    paddingRight: theme.spacing(1),
  },
  logoImage: {
    maxHeight: 34,
    marginLeft: -2, // A small adjustment to make it vertically centered with SplitMenu icons
    width: 'auto'    
  },
  leftMenuBar: {
    paddingRight: theme.spacing(1),
    display: 'flex',
    alignItems: 'center'
  },
  centerMenuBar: {
    flexGrow: 1,
    align: 'center',
    display: 'flex',
    justifyContent: 'center',
  },
  rightMenuBar: {
    paddingLeft: theme.spacing(1),
    display: 'flex',
    alignItems: 'center',
    height: '100%'
  },
  titleText: {
    fontWeight: 800,
    fontSize: theme.typography.body1.fontSize,
//    color: '#aaa'
  },
  businessTitle: {
    textTransform: 'none',
    fontWeight: 400,
    fontSize: theme.typography.body1.fontSize,
    color: '#000'
  },
  titleButton: {
    textTransform: 'none',
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 700,
    color: '#777'
  },
  titleButtonBold: {
    textTransform: 'none',
    fontSize: theme.typography.body1.fontSize,
    fontWeight: 700,
    //color: '#555'
    //color: theme.palette.primary.main
  },
  menuItemDefault: {
    paddingTop: '3px',
    paddingBottom: '3px',
    flexShrink: 0
  },
  menuItemSelected: {
    position: 'relative',
    flexShrink: 0
    //paddingTop: '3px',
    //borderBottom: `3px solid ${theme.palette.primary.main}`
  },
  menuSeparator: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: '1px',
    height: '100%', 
    backgroundColor: '#ccc'
  }
})

const MainBar = ({ theme, classes, menuItems, rightMenuItems, location, variant, backgroundColor, user, companies, company, business, setActiveCompany, login, logout}) => {
  
  const visibleMenuItems = menuItems || [
    { title: "Home", link_to: "/" }
  ]
  
  const path = location.pathname
  let activeMenuIndex = visibleMenuItems.findIndex(item => {
    if (path == item.linkTo)
        return true
    if (item.linkTo != "/" && path.startsWith(item.linkTo))
        return true
    if (item.matchAlso)
      return item.matchAlso.find(to => path.startsWith(to))
  })
  
  const [menuAnchorEl, setMenuAnchorEl] = useState(null)

  const showMenu = event => {
    setMenuAnchorEl(event.currentTarget);
  }

  const hideMenu = () => {
    setMenuAnchorEl(null);
  }
  
  const activateCompany = (c) => {
    setActiveCompany(c.uid)
    // Reload
    setTimeout(() => window.location.reload(), 0)
  }
  
  let rootStyle = {}
  if (variant == 'transparent')
    rootStyle['backgroundColor'] = 'inherit'
  else if (backgroundColor)
    rootStyle['backgroundColor'] = backgroundColor
    
  return (
    <Paper className={classes.root}
      elevation={0}
      style={rootStyle}
      >
      <div className={classes.leftMenuBar}>
        <Box ml={1} mr={3}>
          <Link to="/" style={{ display: 'flex', alignItems: 'center'}}>
            <img className={classes.logoImage} src={ business.data.logo.image_url } />          
          </Link>
        </Box>

        { visibleMenuItems.map((item, index) =>
          <Box 

            className={index == activeMenuIndex ? classes.menuItemSelected : classes.menuItemDefault}>

            { index == activeMenuIndex && 
              <div style={{
                height: '2px',
                position: 'absolute',
                backgroundColor: theme.palette.primary.main,
                width: '100%',
                bottom: -6,
              }}
              />
            }

            <Button color='inherit' 
              className={index == activeMenuIndex ? classes.titleButtonBold : classes.titleButton}
              component={Link}
              style={{
                paddingLeft: theme.spacing(3),
                paddingRight: theme.spacing(3)
              }}
              to={item.linkTo}
              >
              { item.title }
            </Button>
          </Box>

          )}
      </div>
      <div className={classes.centerMenuBar}>
        {process.env.REACT_APP_MAIN !== 'admin' &&
          <SearchBarView />
        }
      </div>
      <div className={classes.rightMenuBar}>
        { rightMenuItems && rightMenuItems.map((item, index) =>
          <Box mr={1} className={classes.menuItemDefault}>
            <Button color='primary' className={classes.titleButtonBold}
              component={item.href ? 'button' : Link}
              to={item.linkTo}
              href={item.href}
              >
              { item.title }              
            </Button>
          </Box>
          )
        }
          
        { user.isLoggedIn ?
          <>
          <Box className={classes.menuItemDefault}>
            <Button color='primary' className={classes.titleButton}
              onClick={showMenu}
              >
              <UserIcon />&nbsp;
              { user.userInfo.first_name } { user.userInfo.last_name }
            </Button>
          </Box>
          <Menu
            id={menuAnchorEl ? 'status-menu-popover' : undefined}
            open={Boolean(menuAnchorEl) }
            anchorEl={menuAnchorEl}
            getContentAnchorEl={null}
            onClose={hideMenu}
            keepMounted
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'right',
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right',
            }}        
            >
            { companies && companies.length > 0 &&
              <>
                { companies.map(c => (
                    <MenuItem
                      onClick={() => activateCompany(c)}
                      >
                      { company && c.uid === company.uid &&
                        <CheckedIcon />
                      }
                      { c.name }
                    </MenuItem>
                  ))
                }
                <Divider />
              </>
            }
            <MenuItem>
              <ListItemText primary="My Account" />
            </MenuItem>
            <MenuItem onClick={ logout }>
              <ListItemText primary="Log Out" />
            </MenuItem>
          </Menu>
          </>
        :
          <Button color='inherit' 
            className={classes.titleButton}
            onClick={() => login()}
            >
            <UserIcon />
            <Box mr={.5} />
            Register / Login
          </Button>          
        }
      </div>
    </Paper>
  )
}

const mapStateToProps = (state, ownProps) => {
  return {
    user: getUser(state),
    business: getBusinessInfo(state, '0'),
    company: getUser(state).companyInfo,
    companies: getCompanies(state)
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  let callbackUrl = window.location.href
  
  return {
    login: () => { dispatch(login(callbackUrl)) },
    logout: () => { dispatch(logout(callbackUrl)) },
    setActiveCompany: (companyUid) => { dispatch(setActiveCompany(companyUid))}
  }
}

export default withRouter(
  withStyles(styles, { withTheme: true })(
    connect(
      mapStateToProps,
      mapDispatchToProps
    )(MainBar)
  )
)
